import ScrollMagic from "scrollmagic"

const smids = ["movie", "message", "history", "obog", "talk", "links"]

function sminit() {
    let controller = new ScrollMagic.Controller();
    smids.forEach(id => {
        new ScrollMagic.Scene({
                triggerElement: `#${id}`,
                duration: document.getElementById(id).clientHeight,
            })
            .setClassToggle(`#${id}li`, "current")
            .addTo(controller);
    });
}

sminit()
window.addEventListener('resize', sminit);
//リサイズで高さ変わる対策